import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import userStore from 'entities/user/module/user-store'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

export const UserInfoCard = observer(() => {
  const { account } = userStore
  const navigate = useNavigate()

  const fullName =
    `${account?.last_name || ''} ${account?.first_name || ''} ${account?.middle_name || ''}`.trim()

  const handleEditClick = () => {
    navigate(RoutingPaths.profileDetail.path())
  }

  return (
    <div className={s.container}>
      <p className={clsx(s.name, 'bold-18')}>{fullName || '-'}</p>
      <div className={s.emailContainer}>
        <p className={clsx(s.email, 'medium-13')}>{account?.email || ''}</p>
        <button
          className={s.editButton}
          onClick={handleEditClick}
          type="button"
        >
          <AppIcon
            id={AllIcons.PENCIL}
            height={12}
            width={12}
            className={s.editIcon}
          />
        </button>
      </div>
    </div>
  )
})
